/**
 * DevExtreme (core/polyfills/promise.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
var $ = require("jquery"),
    Promise = window.Promise;
if (!Promise) {
    Promise = function(resolver) {
        var d = $.Deferred();
        resolver(d.resolve.bind(this), d.reject.bind(this));
        return d.promise()
    };
    Promise.resolve = function(val) {
        return $.Deferred().resolve(val).promise()
    };
    Promise.reject = function(val) {
        return $.Deferred().reject(val).promise()
    };
    Promise.all = function(promises) {
        return $.when.apply($, promises).then(function() {
            return $.makeArray(arguments)
        })
    }
}
module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/core/polyfills/promise.js
// module id = ../../../../devextreme/core/polyfills/promise.js
// module chunks = 3